import { axios } from '@Root/API'

export const edit = (id, payload) => {
	return axios.post(`upload/attachment/${id}`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}
